import { useEffect } from 'react'
import Itemcampaign from '../../../components/itemCampaign'
import { getAllCampaigns, getCampaigns } from '../../../store/campaign'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import Error from '../../../components/error'
import { ErrorType } from '../../../store/errorType'
import { editToken, refreshtoken, sesisonExpired } from '../../../store/user'
import useFetchtoken from '../../../customHooks/useFetchToken'
const Listcampaign = () => {
  const dispatch = useAppDispatch()
  const { list, status, errorMessage, errorType } = useAppSelector(state => state.campaign)
  const { token } = useAppSelector(state => state.user)

  // const data = dispatch(getCampaigns())
  // useEffect(function () {
  //   const promise = dispatch(getCampaigns())
  //   promise.then((response: any) => {
  //     if (response.error?.message === 'Request failed with status code 508') {
  //       dispatch(sesisonExpired())
  //       return null;
  //     }
  //     if (response.meta.requestStatus === 'fulfilled') {
  //       dispatch(refreshtoken())
  //       return null;
  //     }
  //   })

  //   return () => {
  //     promise.abort()
  //   }
  // }, [])

  useEffect(() => {
    setTimeout(()=> {
      
      dispatch(getCampaigns())
    
    },200)
    // if(token) {
    //   dispatch(getCampaigns())
    // }
  }, [])

  //dispatch(getCampaigns())

  if (status === 'getCampaigns_loading') {
    return (
      <div className="c-list-campaigns">
        <div className="c-skeleton-campaign__item">
          <div className="c-skeleton-campaign__header">
            <div className="c-skeleton-campaign__logo" />
            <div className="c-skeleton-campaign__title" />
          </div>
          <span className="c-skeleton-campaign__info" />
          <button className="c-skeleton-campaign__button" />
        </div>
        <div className="c-skeleton-campaign__item">
          <div className="c-skeleton-campaign__header">
            <div className="c-skeleton-campaign__logo" />
            <span className="c-skeleton-campaign__title" />
          </div>
          <span className="c-skeleton-campaign__info" />
          <button className="c-skeleton-campaign__button" />
        </div>
        <div className="c-skeleton-campaign__item">
          <div className="c-skeleton-campaign__header">
            <div className="c-skeleton-campaign__logo" />
            <span className="c-skeleton-campaign__title" />
          </div>
          <span className="c-skeleton-campaign__info" />
          <button className="c-skeleton-campaign__button" />
        </div>
        <div className="c-skeleton-campaign__item">
          <div className="c-skeleton-campaign__header">
            <div className="c-skeleton-campaign__logo" />
            <span className="c-skeleton-campaign__title" />
          </div>
          <span className="c-skeleton-campaign__info" />
          <button className="c-skeleton-campaign__button" />
        </div>
      </div>
    )
  }

  if (status === 'getCampaigns_rejected') {
    return (
      <>
        {
          errorType === ErrorType.ERROR_SERVER && <Error type='error' message={errorMessage} />
        }
        {
          errorType === ErrorType.ERROR_PERMISSION && <Error type='problem' message={errorMessage} />
        }
      </>
    )
  }
  /* if(list.length === 0){

    return(
      <>
      {
          errorType === ErrorType.ERROR_SERVER && <Error type='error' message={errorMessage} />
      }
      {
          errorType === ErrorType.ERROR_PERMISSION && <Error type='problem' message={errorMessage} />
      }
      </>
    )
  } */
  return (
    <div className="c-list-campaigns">
      <div className="c-list-campaigns__header-page">
        <span className="c-list-campaigns__header-page__title">Let’s Get Started</span>
        <span className="c-list-campaigns__header-page__description">Below are the active PURLs campaigns that have been assigned to you.</span>
      </div>
      {
        list.map((c: any, i) => <Itemcampaign key={i} {...c} />)
      }
    </div>
  )
}

export default Listcampaign